import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import AdminGroupList from "../../components/AdminGroup";

const AdminGroupPage = (): ReactElement => {
  return (
    <Layout>
      <AdminGroupList />
    </Layout>
  );
};

export default AdminGroupPage;
